export enum TransactionStatus {
  FAILED = 'failed',
  PENDING = 'pending',
  SCHEDULED = 'scheduled',
  CAPTURED = 'captured',
  UNKNOWN = 'unknown',
}
